import { Host, h } from '@stencil/core';
export class AibaQuizIntro {
  constructor() {
    this.handleClick = undefined;
    this.data = undefined;
    this.classes = undefined;
    this.styles = undefined;
    this.handlers = undefined;
    this.heading = undefined;
  }
  async componentWillRender() {
    var _a, _b, _c;
    if (this.handlers && this.handlers.handleUserName) {
      this.heading = await this.handlers.handleUserName((_c = (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.elements[0]) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.text);
    }
  }
  componentDidLoad() {
    this.handlers && this.handlers.quizIntrohandler();
  }
  render() {
    var _a, _b, _c;
    if (typeof this.data === 'string') {
      if (this.data)
        this.data = JSON.parse(this.data);
    }
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: `quiz-intro-wrapper` }, ((_a = this.data) === null || _a === void 0 ? void 0 : _a.elements) &&
      ((_c = (_b = this.data) === null || _b === void 0 ? void 0 : _b.elements) === null || _c === void 0 ? void 0 : _c.map(element => {
        var _a, _b, _c;
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-label') {
          if (((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.tag) === 'h2' && this.heading) {
            element.data.text = this.heading;
          }
          return h("aiba-label", Object.assign({}, element.data));
        }
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-prev-button') {
          return (h("aiba-button", Object.assign({}, element.data, { handleClick: event => this.handlers && this.handlers.handlePrevQuestionClick && this.handlers.handlePrevQuestionClick(event), classes: element && element['data'] })));
        }
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-button') {
          return (h("aiba-button", Object.assign({}, element.data, { handleClick: event => { var _a, _b; return this.handleClick(event, ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a._id) ? (_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b._id : ''); }, classes: element && element['data'] })));
        }
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-image') {
          return (h("div", { class: "quiz-intro-image" }, h("img", { src: (_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.src, alt: (_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.altText })));
        }
        if (element && element['name'] === 'aiba-hero-image') {
          return h("aiba-hero-image", Object.assign({}, element['data']));
        }
      })))));
  }
  static get is() { return "aiba-quiz-intro"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-quiz-intro.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-quiz-intro.css"]
    };
  }
  static get properties() {
    return {
      "handleClick": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handle-click",
        "reflect": false
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "heading": {}
    };
  }
}
//# sourceMappingURL=aiba-quiz-intro.js.map
